import { useEffect } from 'react'

import { beginSessionRecording } from '@/services/sessionRecordingService'

export function useSessionRecording(enabled: boolean) {
    useEffect(() => {
        if (!enabled) return
        let recording: ReturnType<typeof beginSessionRecording> | undefined
        const start = () => {
            recording ??= beginSessionRecording()
        }
        // React's StrictMode setup/cleanup replay must not create two recordings.
        const timer = setTimeout(start, 0)
        const stop = () => {
            clearTimeout(timer)
            void recording?.stop()
            recording = undefined
        }
        const restore = (event: PageTransitionEvent) => {
            if (event.persisted) start()
        }
        window.addEventListener('pagehide', stop)
        window.addEventListener('pageshow', restore)
        return () => {
            window.removeEventListener('pagehide', stop)
            window.removeEventListener('pageshow', restore)
            stop()
        }
    }, [enabled])
}
